import { IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonItem, IonLabel, IonRow } from "@ionic/react"
import CoinChart from "../../components/CoinChart"
import { Browser } from "@capacitor/browser";
import { useTranslation } from "react-i18next";
import { globeOutline } from "ionicons/icons";
import { Asset } from "../../types/types";
import { useAppSelector } from "../../services/redux/hook";
import { RootState } from "../../services/redux/store";

interface MyProps {
    asset:Asset
}
const MarketInfo: React.FC<MyProps> = ({asset}) => {

    const { t, i18n } = useTranslation();
    const language = useAppSelector((state:RootState) => state.language);
    
    const goToAssetWebsite = async (url: string) => {

        await Browser.open({ url: url });

    }

    return (
        <>
            <IonCard>
                <IonCardContent>

                    <CoinChart />

                </IonCardContent>
            </IonCard>

            <IonCard>
                <IonGrid>
                    <IonRow>
                        <IonCol>

                            <IonItem lines="none">
                                <IonLabel aria-setsize={10}>
                                    {`${t('accounts.details.ABOUT-ASSET')} ${asset.name}`}
                                </IonLabel>
                            </IonItem>

                            <IonCardContent className="ion-text-start">
                                {asset.description[language]}
                            </IonCardContent>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>

                            <IonItem lines="none">
                                <IonIcon slot="start" icon={globeOutline} color="primary"></IonIcon>
                                <IonLabel onClick={() => { goToAssetWebsite(asset.description.website) }}> {t('accounts.details.ASSET-WEBSITE')}</IonLabel>
                            </IonItem>

                        </IonCol>
                    </IonRow>
         
                </IonGrid>

            </IonCard>

        </>
    )
}

export default MarketInfo